<template>
    <v-row class="mt-5 text-center" no-gutters>
        <v-col cols="12">
            <div class="display-1 mb-3">{{ $t('Communication timeline') }}</div>
        </v-col>
        <v-col cols="12">
            <div class="subtitle-1 grey--text mb-4 mx-auto" style="max-width: 500px;">{{ $t('Activate Email App in App Store to send automated emails and view your past and future communication in one place.') }}</div>
        </v-col>
        <v-col cols="12">
            <v-btn large color="primary" class="inverted--text elevation-0" @click="openAppStore">
                <span class="font-weight-bold">{{ $t("Go to App Store") }}</span>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { APP_STORE_APP_TYPES } from "@/helpers/constants";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import { Router } from "@/composables/Router";

export default {
    name: "EmailDisabled",
    props: {
        companyId: {
            type: Number,
            required: true
        }
    },
    setup(props) {
        const router = Router()
        const { appStoreDialogActions } = appStoreDialog()

        const openAppStore = app => {
            appStoreDialogActions.openAppStoreModal(
                APP_STORE_APP_TYPES.EMAILING,
                props.companyId,
                {
                    onUpdate: () => {}
                }
            )

            router.push({ name: 'app_store', params: { accountId: props.companyId }})
        };

        return {
            openAppStore
        }
    }
};
</script>
